import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>SOFTWARE AUTOMATION</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                  We develop intelligent software platforms and automation frameworks that eliminate repetitive manual tasks and streamline business processes. From Robotic Process Automation (RPA) and workflow orchestration to DevOps pipeline automation, our solutions enhance productivity, reduce operational costs, and ensure consistency. We work closely with clients to automate customer service, data processing, document generation, and more—tailored to specific industry needs.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-gear-wide-connected fa-3x mb-3 text-primary"></i>
        <hr className="my-3" />
        <h5>Process Automation</h5>
        <div className="btSubTitle small">
          Streamlining multi-step business processes—like onboarding, approvals, or inventory updates—using tools like RPA (Robotic Process Automation) or workflow automation platforms.
        </div>
        <hr className="my-3" />
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-backpack2 fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>Task Automation</h5>
        <div className="btSubTitle small">
          Automating repetitive, rule-based tasks such as data entry, file transfers, report generation, or sending notifications using scripts or automation tools.
        </div>
        <hr className="mt-4" />
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-bookmark-plus fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Software Testing Automation</h5>
        <div className="btSubTitle small">
          Using specialized tools to automatically test software applications, ensuring quality and reducing time in QA cycles.
        </div>
        <hr className="mt-4" />
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
